// Slider functionality
export function initializeSliderMiniHome() {
  const sliderMini = document.querySelector('.empower-block__slider-mini-home');
  if (sliderMini) {
    jQuery(sliderMini)
      .on('init', function () {
        sliderMini.style.visibility = 'visible';
      })
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
      });
  }
}

export function initEventSlider() {
  const sliderSelector = '.slider-items';
  const $slider = jQuery(sliderSelector);
  let isSlickActive = false;

  function activateSlider() {
    $slider.off('init').on('init', function () {
      $slider.css('visibility', 'visible');
    });

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        responsive: [{ breakpoint: 1199, settings: { slidesToShow: 2 } }],
      });
      isSlickActive = true;
    }
  }

  function deactivateSlider() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      $slider.css('visibility', 'visible'); // para que no quede oculto
      isSlickActive = false;
    }
  }

  function checkSlider() {
    if (window.innerWidth > 860) {
      activateSlider();
    } else {
      deactivateSlider();
    }
  }

  checkSlider();
  jQuery(window).on('resize', checkSlider);
}

export function initTestimonialSlider() {
  const slider = document.querySelector('.testimonials-slider .wp-block-group__inner-container');

  if (slider) {
    jQuery(slider)
      .on('init', function () {
        slider.style.visibility = 'visible';
      })
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: 'unslick', // destroys slick
          },
        ],
      });
  }
}
